import './forecast-today';
import thirtyDaysModal from './components/thirty-days-modal';

thirtyDaysModal.init();
